export class MaintenanceObject {
    Description: string;
    ETag: string; 
    Inventory: number; 
    Is_In_Basket: boolean;
    Item_Description: string;
    Item_No: string;
    Shelf_No?: string;
    No: string;
    Partial_No: string;
    Quantity: number;
    Root_No: string;
  }



// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/entities/MaintenanceObject.ts